import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import ArrowButton from "../ArrowButton";
import RewardCard from "../RewardCard";
import "./style.scss";
import "swiper/css";
import "swiper/css/navigation";
import placeHolder1 from "./img/placeHolder1.jpg";
import placeHolder2 from "./img/placeHolder2.jpg";
import placeHolder3 from "./img/placeHolder3.jpg";
import placeHolder4 from "./img/placeHolder4.jpg";
import SectionHeader from "@components/SectionHeader";
import Button from "@components/Button";
import { useWindowSize } from "@app/Helpers";

export default function RewardsSlider({ hasPrime }) {
  const { width } = useWindowSize();
  const XGA = width >= 1020;

  const prizeCardPlaceholder = [
    {
      uuid: "placeholder-prize",
      ident: "",
      content: {
        title:
          "<strong>Kostenfreier Akkuaustausch, </strong><br/> wenn dein Device Power braucht",
        copy: "",
      },
      thumbnail: {
        file: {
          url: placeHolder1,
        },
      },
      disabled: hasPrime ? false : true,
    },
    {
      uuid: "placeholder-prize",
      ident: "",
      content: {
        title:
          "Erstzugang zu neuen <br/><strong>Produkten und speziellen Angeboten</strong>",
        copy: "",
      },
      thumbnail: {
        file: {
          url: placeHolder2,
        },
      },
      disabled: hasPrime ? false : true,
    },
    {
      uuid: "placeholder-prize",
      ident: "",
      content: {
        title: "Einladungen zu <strong>exklusiven<br/> Prime‑Events</strong>",
        copy: "",
      },
      thumbnail: {
        file: {
          url: placeHolder3,
        },
      },
      disabled: hasPrime ? false : true,
    },
    {
      uuid: "placeholder-prize",
      ident: "",
      content: {
        title:
          "Premium-Kundenservice <br/><strong>mit priorisiertem Abo‑Support</strong>",
        copy: "",
      },
      thumbnail: {
        file: {
          url: placeHolder4,
        },
      },
      disabled: hasPrime ? false : true,
    },
  ];

  return (
    <div className="sub-rewards-swiper">
      <div className="sub-header">
        <SectionHeader>
          <span>Nur mit</span>
          <strong> Prime</strong>
        </SectionHeader>
        {XGA && (
          <Button
            btnClass="ultra-insider"
            href={`${import.meta.env.VITE_VUSE_URL}/vorteils-abo/?utm_source=IC&utm_medium=Dashboard&utm_campaign=PremiumAbo`}
          >
            Jetzt upgraden
          </Button>
        )}
      </div>

      <div className="sub-slider">
        <div className="slider">
          <div className="cta-group">
            <div className="swiper-button-prev prize">
              <ArrowButton reverse />
            </div>
            <div className="swiper-button-next prize">
              <ArrowButton />
            </div>
          </div>
          <Swiper
            className="premiumSwiper-prize"
            modules={[Navigation]}
            spaceBetween={28}
            slidesPerView={1.1}
            navigation={{
              nextEl: ".swiper-button-next.prize",
              prevEl: ".swiper-button-prev.prize",
            }}
            breakpoints={{
              720: {
                slidesPerView: "auto",
                spaceBetween: 20,
              },
            }}
          >
            {prizeCardPlaceholder.map((e, idx) => {
              return (
                <SwiperSlide key={idx}>
                  <RewardCard
                    title={e.content?.title}
                    copy={e.content?.copy}
                    img={e.thumbnail?.file?.url}
                    key={idx}
                    ident={e.ident}
                    href={e.ident}
                    disabled={e.disabled}
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
      {!XGA && (
        <div className="mobile-btn">
          <Button
            btnClass="ultra-insider"
            href={`${import.meta.env.VITE_VUSE_URL}/vorteils-abo/?utm_source=IC&utm_medium=Dashboard&utm_campaign=PremiumAbo`}
          >
            Jetzt upgraden
          </Button>
        </div>
      )}
    </div>
  );
}
